import { watch } from "vue";
import { useRoute } from "vue-router";

/**
 * Used to call a callback when the user exits a given route (name).
 */
export function useOnRouteExit(routeName: string, callback: () => void) {
  const route = useRoute();

  watch(
    () => route.name,
    (current, previous) => {
      if (current === previous) return;
      if (previous === routeName && current !== routeName) {
        callback();
      }
    },
  );
}
